import { Endereco } from "./Endereco.ts";
import { Pessoa } from "./Pessoa.ts";

export class Instrumentador extends Pessoa {
  ativo: boolean;
  cpf: string;
  endereco: Endereco;
  notificarEmail: boolean;

  constructor(
    id = 0,
    nome = "",
    cpf = "",
    email = "",
    telefone = "",
    notificarEmail: false,
    endereco: Endereco
  ) {
    super(id, nome, email, telefone);
    this.cpf = cpf;
    this.notificarEmail = notificarEmail;
    this.endereco = endereco || new Endereco();
  }

  excluir() {
    this.ativo = false;
  }
}
